import { useEffect, useRef, useState } from "react";
import { Button, Label, TextInput } from "flowbite-react";
import "./CreateTroc.css";
import { array, boolean, date, object, ref, string } from "yup";
import { useFormik } from "formik";
import { createTrocT } from "../../services/callAPI/toTravelerTrocs";
import { travServicesList } from "../../services/utils/travServicesList/services";
import { travNeedsList } from "../../services/utils/travNeedsList/needs";
import { resServicesList } from "../../services/utils/resServicesList/servicesList";
import { resNeedsList } from "../../services/utils/resNeedsList/needsList";
import UnvalidToast from "../toasts/UnvalidToast";
import { createTrocR } from "../../services/callAPI/toResidentsTrocs";
import ValidToast from "../toasts/ValidToast";
import { isSanitizeValue } from "../../services/hooks/sanitizeValue/isSanitizeValue";
import { cleanInputValue } from "../../services/hooks/sanitizeValue/cleanInputValue";
import { isPhoneNumberDetected } from "../../services/hooks/sanitizeValue/is-phone-number-detected";
import { cleanTitleValue } from "../../services/hooks/sanitizeValue/cleanTitleValue";
import { isSanitizeDescripValue } from "../../services/hooks/sanitizeValue/isSanitizeDescipValue";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { regionsAndDpt } from "../../services/utils/regions/regionsAndDept";

interface ICreateTrocProps {
  canIcreateTroc: boolean;
  triggerUseffect2: boolean;
  userRole: string | null;
  setTriggerUseEffect2: React.Dispatch<React.SetStateAction<boolean>>;
}

function CreateTroc(props: ICreateTrocProps) {
  //destructuring
  const { canIcreateTroc, userRole, triggerUseffect2, setTriggerUseEffect2 } = props;

  const [activedButton, setActivedButton] = useState<boolean>(canIcreateTroc);

  const [openModal, setOpenModal] = useState(false);

  const [services, setServices] = useState<string[]>(["", "", ""]); // Contient les sélections des 3 champs

  const [needs, setNeeds] = useState<string[]>(["", "", ""]); // Contient les sélections des 3 champs

  const [showDropdownServices, setShowDropdownServices] = useState<boolean[]>([false, false, false]); // Contrôle l'affichage des listes

  const [showDropdownNeeds, setShowDropdownNeeds] = useState<boolean[]>([false, false, false]); // Contrôle l'affichage des listes

  const [validToast, setvalidToast] = useState<boolean>(false);

  const [unvalidToast, setUnvalidToast] = useState<boolean>(false);

  const [openPopup, setOpenPopup] = useState<boolean>(false);

  const [currentDropdownService, setCurrentDropdownService] = useState<number | null>(null);

  const [currentDropdownNeeds, setCurrentDropdownNeeds] = useState<number | null>(null);

  const dropdownRefsService = useRef<(HTMLUListElement | null)[]>([]);

  const dropdownRefsNeeds = useRef<(HTMLUListElement | null)[]>([]);

  const userRegion = useSelector((state: RootState) => state.user.region);

  //define maxDate of 30 days after current date
  const today = new Date();

  const maxDate = new Date(today);

  maxDate.setDate(today.getDate() + 30);

  const [_dataForm, setDataForm] = useState<{
    title: string;
    services: [string, string?, string?];
    needs: [string, string?, string?];
    start_time: string;
    end_time: string;
    flexible: boolean;
    description: string;
    departement: string;
  }>({
    title: "",
    services: [""],
    needs: [""],
    start_time: "",
    end_time: "",
    flexible: false,
    description: "",
    departement: ""
  });

  function onCloseModal() {
    resetForm();
    setOpenModal(false);
    setServices(["", "", ""]);
    setNeeds(["", "", ""]);
    setShowDropdownServices([false, false, false]);
    setShowDropdownNeeds([false, false, false]);
  }

  const handleSelectServices = (index: number, value: string) => {
    const updatedInputs = [...services];
    updatedInputs[index] = value;
    setFieldValue("services", updatedInputs);
    setServices(updatedInputs); //redefine services

    const updatedDropdown = [...showDropdownServices];
    updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
    setShowDropdownServices(updatedDropdown);
  };

  const handleSelectNeeds = (index: number, value: string) => {
    const updatedInputs = [...needs];
    updatedInputs[index] = value;
    setFieldValue("needs", updatedInputs);
    setNeeds(updatedInputs); //redefine needs

    const updatedDropdown = [...showDropdownNeeds];
    updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
    setShowDropdownNeeds(updatedDropdown);
  };

  const toggleDropdownServices = (index: number) => {
    //reset content all showDropdownServices to false
    const dropdownReset = showDropdownServices.map(() => false);

    dropdownReset[index] = !showDropdownServices[index]; // inverse state (open/close)
    setShowDropdownServices(dropdownReset);
  };

  const toggleDropdownNeeds = (index: number) => {
    //reset content all showDropdownNeeds to false
    const dropdownReset = showDropdownNeeds.map(() => false);

    dropdownReset[index] = !showDropdownNeeds[index];  // inverse state (open/close)
    setShowDropdownNeeds(dropdownReset);
  };

  const handleButtonCreate = () => {
    if (activedButton) {
      setOpenModal(true);  // Action réelle lorsque le bouton est activé
    }
    else {
      //show pop up adequate
      setOpenPopup(true);
    }
  };

  //set validation schema with Yup
  const dataFormSchema = object({
    role: string()
      .oneOf(["RESIDENT", "TRAVELER"], "Rôle invalide")
      .required(),
    title: string()
      .trim()
      .required("donner un titre")
      .transform((value) => value.replace(/\s+/g, ' ').trim())
      .min(5, "Le titre doit comporter au moins 5 caractères")
      .max(50, "Le titre ne peut pas dépasser 50 caractères")
      .test("is-title-valid", "Le titre contient des caractères non-imprimables ou interdits", (value) => isSanitizeValue(value)),
    services: array()
      .test("is-not-empty", "Renseigner au moins un service", (value) => {
        return value?.some((item) => !!item) ?? false
      })
      .max(3, "3 services maximum")
      .of(string().oneOf([...travServicesList, ...resServicesList], "Service invalide")),
    needs: array()
      .test("is-not-empty", "Renseigner au moins un besoin", (value) => {
        return value?.some((item) => !!item) ?? false
      })
      .max(3, "3 besoins maximum")
      .of(string().oneOf([...travNeedsList, ...resNeedsList], "Besoin invalide")),
    departement: string()
      .when('role', {
        is: "RESIDENT",
        then: (schema) => schema.required("département manquant"),
        otherwise: (schema) => schema.notRequired(),
      }),
    flexible: boolean(),
    start_time: date()
      .required("indiquez la date de début"),
    end_time: date()
      .min(ref("start_time"), "La date de fin doit être après la date de début")
      .required("indiquez la date de fin"),
    description: string()
      .trim()
      .required("précisez ce que vous offrez et ce dont vous avez besoin")
      .min(5, "5 caractères minimum")
      .max(750, "750 caractères maximum")
      .test('no-phone', 'La description ne doit pas contenir de numéro de téléphone', isPhoneNumberDetected)
      .test("is-description-valid", "La description contient des caractères non-imprimables ou interdites", (value) => isSanitizeDescripValue(value)),
  })

  //set formik
  const { handleSubmit, handleChange, errors, touched, isSubmitting, values, setFieldValue, resetForm } = useFormik({
    initialValues: {
      role: userRole,
      title: "",
      services: [""] as [string, string?, string?],
      needs: [""] as [string, string?, string?],
      flexible: false,
      start_time: "",
      end_time: "",
      description: "",
      departement: ""
    },
    validationSchema: dataFormSchema,
    onSubmit: async values => {
      try {
        //filter services and needs for api by removing empty indexes
        let filteredServices = values.services.filter((service) => service);
        let filteredNeeds = values.needs.filter((need) => need);

        //replace spaces by underscores into filteredServices and filteredNeeds
        filteredServices = filteredServices.map((service) => service?.replace(/ /g, "_"));
        filteredNeeds = filteredNeeds.map((need) => need?.replace(/ /g, "_"));

        let data: {
          canIcreateTroc: boolean;
        } | undefined = undefined;

        switch (userRole) {
          case "TRAVELER":
            data = await createTrocT({ ...values, services: filteredServices, needs: filteredNeeds });
            break;
          case "RESIDENT":
            data = await createTrocR({ ...values, services: filteredServices, needs: filteredNeeds });
            break;
          default:
            data = undefined;
            break;
        }

        if (data) {
          setvalidToast(true);

          //update dataForm
          setDataForm(values);

          //redefine activedButton's state
          setActivedButton(data.canIcreateTroc);

          setTriggerUseEffect2(!triggerUseffect2);
        }
        else {
          throw new Error(`Une erreur est survenue.`);
        }
      }
      catch (error) {
        //redefine activedButton's state
        setActivedButton(false);

        //redifine unvalidToast
        setUnvalidToast(true);
      }
      finally {
        //close form
        onCloseModal();
      }
    }
  })

  useEffect(() => {
    setActivedButton(canIcreateTroc);
  }, [canIcreateTroc]);

  // Gérer le clic à l'extérieur pour fermer le dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {

      dropdownRefsService.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target as Node)) {
          const updatedDropdown = [...showDropdownServices];
          updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
          setShowDropdownServices(updatedDropdown);

          if (currentDropdownService === index) {
            setCurrentDropdownService(null); // Réinitialiser l'état si le dropdown actuel est fermé
          }
        }
      });

      dropdownRefsNeeds.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target as Node)) {
          const updatedDropdown = [...showDropdownNeeds];
          updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
          setShowDropdownNeeds(updatedDropdown);

          if (currentDropdownNeeds === index) {
            setCurrentDropdownNeeds(null); // Réinitialiser l'état si le dropdown actuel est fermé
          }
        }
      })
    };

    document.addEventListener("mousedown", handleClickOutside); // Écouteur d'événements pour le clic

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Nettoyage
    };
  }, []);

  return (
    <>
      {openPopup && <UnvalidToast message="Nombre de création de troc atteint !" onClose={() => setOpenPopup(false)} />}
      {unvalidToast && <UnvalidToast message="Une erreur est survenue. Rééssayez plus tard ou contactez nous." onClose={() => setUnvalidToast(false)} />}
      {validToast && <ValidToast onClose={() => setvalidToast(false)} />}

      <Button
        id="btn-create-troc"
        style={{ backgroundColor: '#E09F3E', color: 'white' }}
        className={`self-end ${activedButton ? "" : "opacity-50"}`}
        onClick={handleButtonCreate}
      >
        Créer un élément à échanger
      </Button>

      {openModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-2"
          onClick={onCloseModal}
        >
          <div
            className="w-full max-w-2xl bg-gray-300 rounded-3xl max-h-[90vh] overflow-y-auto p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <form className="flex flex-col gap-4 mt-6" noValidate onSubmit={handleSubmit}>

              {/* insert title */}
              <div id="title" className="flex flex-col gap-2">
                <Label className="font-bold text-center" htmlFor="title" value="Titre du Troc" />

                <TextInput
                  className="flex-1"
                  placeholder="Exemple: Livraison de course contre prêt de vélo"
                  id="title"
                  type="text"
                  name="title"
                  onChange={(e) => {
                    const cleaned = cleanTitleValue(e.target.value);
                    setFieldValue("title", cleaned);
                  }}
                  value={values.title}
                />
                {touched.title && errors.title && <span className="text-center text-red-500 text-sm">{errors.title}</span>}

              </div>

              {/* insert services and needs */}
              <div className="flex flex-col gap-4" id="services-needs-form">

                {/* insert services */}
                <div className="flex flex-col items-center" id="services">
                  <Label className="font-bold" htmlFor="services" value="Je propose" />

                  <div className="space-y-4">

                    {services.map((_service, index) => (
                      <div key={index} className="relative w-64">
                        <button
                          type="button"
                          onClick={() => toggleDropdownServices(index)}
                          className="block w-full mt-1 rounded-md border border-gray-300 bg-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 text-left"
                        >
                          <input
                            name={`services[${index}]`}
                            readOnly
                            className="w-full border-none focus:outline-none hover:cursor-pointer text-center"
                            onChange={handleChange}
                            value={values.services[index] || "Sélectionnez un service"}

                          />
                        </button>

                        {showDropdownServices[index] && (
                          <ul id="ul-services" ref={(el) => (dropdownRefsService.current[index] = el)} className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {/* Option "Aucun service" */}
                            <li
                              key="none"
                              onClick={() => handleSelectServices(index, "")}
                              className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white text-lightRedCustom font-medium"
                            >
                              Aucun service
                            </li>

                            {userRole === "TRAVELER" ? travServicesList.map((service, itemIndex) => (
                              <li
                                key={itemIndex}
                                onClick={() => handleSelectServices(index, service)}
                                className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                              >
                                {service}
                              </li>
                            )) :
                              resServicesList.map((service, itemIndex) => (
                                <li
                                  key={itemIndex}
                                  onClick={() => handleSelectServices(index, service)}
                                  className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                                >
                                  {service}
                                </li>
                              ))
                            }
                          </ul>
                        )}
                      </div>
                    ))}

                  </div>

                  {touched.services && errors.services && <span className="text-red-500 text-sm">{errors.services}</span>}

                </div>

                {/* insert needs */}
                <div className="flex flex-col items-center" id="needs">
                  <Label className="font-bold" htmlFor="needs" value="J'ai besoin de" />

                  <div className="space-y-4">

                    {needs.map((_need, index) => (
                      <div key={index} className="relative w-64">
                        <button
                          type="button"
                          onClick={() => toggleDropdownNeeds(index)}
                          className="block w-full mt-1 rounded-md border border-gray-300 bg-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 text-left"
                        >
                          <input
                            name={`needs[${index}]`}
                            readOnly
                            className="w-full border-none focus:outline-none hover:cursor-pointer text-center"
                            onChange={handleChange}
                            value={values.needs[index] || "Sélectionnez un besoin"}

                          />
                        </button>

                        {showDropdownNeeds[index] && (
                          <ul id="ul-needs" ref={(el) => (dropdownRefsNeeds.current[index] = el)} className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {/* Option "Aucun besoin" */}
                            <li
                              key="none"
                              onClick={() => handleSelectNeeds(index, "")}
                              className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white text-lightRedCustom font-medium"
                            >
                              Aucun besoin
                            </li>

                            {userRole === "TRAVELER" ? travNeedsList.map((need, itemIndex) => (
                              <li
                                key={itemIndex}
                                onClick={() => handleSelectNeeds(index, need)}
                                className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                              >
                                {need}
                              </li>
                            )) :
                              resNeedsList.map((need, itemIndex) => (
                                <li
                                  key={itemIndex}
                                  onClick={() => handleSelectNeeds(index, need)}
                                  className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                                >
                                  {need}
                                </li>
                              ))
                            }
                          </ul>
                        )}
                      </div>
                    ))}

                  </div>

                  {touched.needs && errors.needs && <span className="text-red-500 text-sm">{errors.needs}</span>}
                </div>

              </div>

              {/* insert troc place */}
              {userRole === "RESIDENT" && (
                <div id="div-place" className="flex flex-col items-center gap-2">
                  <label className="font-bold text-center" htmlFor="place">Lieu</label>

                  <select
                    id="select-dpt"
                    name="departement"
                    className="w-1/2"
                    value={values.departement}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      -- Choisis un département --
                    </option>

                    {regionsAndDpt
                      .find((region) => region.nom === userRegion)
                      ?.departements.map((dpt, index) => (
                        <option
                          key={index}
                          value={dpt.nom}
                        >
                          {dpt.nom}
                        </option>
                      ))
                    }
                  </select>
                  {touched.departement && errors.departement && <span className="text-center text-red-500 text-sm">{errors.departement}</span>}
                </div>
              )}

              {/* insert flexible and date */}
              <div className="flex flex-col" id="troc-time">

                {/* time start and end */}
                <div className="flex flex-col gap-2" id="start-end-time-form">

                  {/* time start */}
                  <div className="flex flex-col items-center" id="start">
                    <label className="text-center" htmlFor="start-time">Début :</label>
                    {<input
                      className="text-center"
                      name="start_time"
                      onChange={handleChange}
                      type="datetime-local"
                      min={new Date().toISOString().slice(0, 16)}
                      max={maxDate.toISOString().slice(0, 16)}
                      value={values.start_time}
                    />}
                    {/* <Datepicker name="start_time" language="fr" minDate={new Date()} placeholder="sélectionner une date" value={selectedDate} onChange={handleDateChange}  key={selectedDate ? selectedDate.toISOString() : "empty"} /> */}
                    {touched.start_time && errors.start_time && <span className="text-red-500 text-sm">{errors.start_time}</span>}
                  </div>

                  {/* time end */}
                  <div className="flex flex-col items-center" id="end">
                    <label className="text-center" htmlFor="end-time">Fin :</label>
                    <input
                      className="text-center"
                      name="end_time"
                      onChange={handleChange}
                      type="datetime-local"
                      min={new Date().toISOString().slice(0, 16)}
                      max={maxDate.toISOString().slice(0, 16)}
                      value={values.end_time}
                    />
                    {touched.end_time && errors.end_time && <span className="text-red-500 text-sm">{errors.end_time}</span>}
                  </div>
                </div>

                {/* flexible */}
                <div className="flex items-center gap-2 mt-1" >

                  <label htmlFor="flexible-checkbox">Flexible</label>

                  <input
                    className="text-greenCustom"
                    id="flexible-checkbox"
                    type="checkbox"
                    name="flexible"
                    onChange={handleChange}
                    checked={values.flexible}
                  />
                </div>

              </div>

              {/* insert description */}
              <div className="flex flex-col gap-3" id="description">

                <label className="font-bold text-center" htmlFor="description">Précision</label>

                <textarea
                  className="rounded-md bg-white p-2"
                  name="description"
                  onChange={(e) => {
                    const cleaned = cleanInputValue(e.target.value);
                    setFieldValue("description", cleaned);
                  }}
                  rows={3}
                  value={values.description}
                />

                {touched.description && errors.description && <span className="text-red-500 text-sm">{errors.description}</span>}

              </div>

              {/*buttons back and create */}
              <div className="flex justify-between" id="btn-close-or-submit">
                <button style={{ backgroundColor: '#540B0E', color: 'white' }} className="w-2/6 font-semibold rounded-md py-2" type="button" onClick={onCloseModal}>Retour</button>
                <button style={{ backgroundColor: '#335C67', color: 'white' }} className="w-2/6 font-semibold rounded-md py-2" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Envoi en cours...' : `Créer`}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
export default CreateTroc;